/* import __COLOCATED_TEMPLATE__ from './custom-ember-table.hbs.js'; */
import Component from '@ember/component';
import { isEmpty, isPresent, isNone } from '@ember/utils';
import { isArray } from '@ember/array';
import { inject as service } from '@ember/service';
import { assert } from '@ember/debug';
import { computed } from '@ember/object';
import { readOnly, map } from '@ember/object/computed';
import { OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
import { get as persistableGet, set as persistableSet } from '@square/dashboard-utilities/utils/persistable';
import { rejectBy } from '@square/dashboard-utilities/macros';
import CustomEmberTableDataCell from '@dashboard/shared-ui/components/custom-ember-table-data-cell';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  i18n: service(),
  environment: service(),
  tagName: '',
  // Passed in from table implementation
  // By default, we do not have variable amount of columns
  hasVariableColumns: false,
  hasCollapseAll: false,
  onCollapseAllToggle: null,
  allCollapsed: true,
  columnsAvailable: null,
  upsellColumns: null,
  upsellColumnClicked: null,
  upsellColumnVertical: null,
  rows: null,
  select: null,
  onRowClick: null,
  rowsAreSelectable: true,
  actionsHash: null,
  showInlineSpinner: false,
  showFullSizeSpinner: false,
  loadNextPage: null,
  cellComponent: null,
  scrollIndicators: null,
  onSortUpdate: () => {},
  // Passed in from the wrapping table. We can handle additional actions after changing the columns
  columnSelectionChanged: () => {},
  // no-op
  persistKey: null,
  selectAllCheckboxState: null,
  init(...args) {
    this._super(...args);
    if (!this.selectedColumnIds) {
      this.set('selectedColumnIds', []);
    }
  },
  // NOTE(cclegg): the lazy rendering behavior of vertical-collection (which ember-table uses internally)
  // makes it difficult to check the table's entire contents in tests.
  renderAll: readOnly('environment.isTesting'),
  didReceiveAttrs() {
    this._super();
    if (!isNone(this.persistKey)) {
      const persistedColumnIds = persistableGet(this.persistKey);
      if (isArray(persistedColumnIds)) {
        this.set('selectedColumnIds', persistedColumnIds);
      }
    }
  },
  defaultColumnAttributes: computed('cellComponent', function () {
    return {
      cellComponent: this.cellComponent ?? CustomEmberTableDataCell,
      tdClass: 'custom-ember-table-data-cell',
      isDefault: true
    };
  }),
  availableColumnsWithDefaultAttrs: map('columnsAvailable', ['defaultColumnAttributes'], function (column) {
    return {
      ...this.defaultColumnAttributes,
      ...column,
      name: column.translationKey ? this.i18n.t(column.translationKey) : ''
    };
  }),
  selectedColumnsWithDefaultAttrs: computed('selectedColumnIds.[]', 'availableColumnsWithDefaultAttrs.[]', function () {
    return isEmpty(this.selectedColumnIds) ? this.availableColumnsWithDefaultAttrs.filter(column => column.alwaysOn || column.isDefault) : this.availableColumnsWithDefaultAttrs.filter(column => column.alwaysOn || this.selectedColumnIds.includes(column.id));
  }),
  selectedColumnsWithoutTableOptions: rejectBy('selectedColumnsWithDefaultAttrs', 'isTableOption'),
  tableOptions: computed('selectedColumnsWithDefaultAttrs.[]', function () {
    return new Set(this.selectedColumnsWithDefaultAttrs.filterBy('isTableOption').mapBy('id'));
  }),
  translatedUpsellColumns: computed('i18n', 'upsellColumns.@each.{id,translationKey}', function () {
    if (this.upsellColumns) {
      return this.upsellColumns.map(column => column.translationKey ? {
        name: this.i18n.t(column.translationKey),
        id: column.id
      } : null).compact();
    }
    return [];
  }),
  actions: {
    saveColumns() {
      assert('Must have persistKey for variable column table to save values in local storage', isPresent(this.persistKey));
      this.set('selectedColumnIds', this.selectedColumnsWithDefaultAttrs.mapBy('id'));
      persistableSet(this.persistKey, this.selectedColumnIds, OneTrustConsent.FUNCTIONAL);
      this.columnSelectionChanged(this.selectedColumnIds);
    },
    invokeOnSortUpdate(column) {
      if (!column.canSort) {
        return;
      }
      this.onSortUpdate(column);
    }
  }
});